// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"9dff5986","167":"6a5a9fde","714":"ebb43c24"}[chunkId] + ".chunk.js";
};